<div class="toast-container position-fixed bottom-0 end-0 p-3">
    <div id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true"
        *ngFor="let toast of toastService.messages()">
        <div class="toast-body d-flex justify-content-between align-items-center p-3 rounded-12">
            <div>
                <svg width="26" *ngIf="toast.type !== 'error'" height="26" class="me-2" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="13" cy="13" r="13" fill="#28B446" />
                    <path d="M7 13L11.0003 17L19 9" stroke="white" stroke-width="2.2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                @if(toast.type === 'error') {
                    <svg width="26" height="26" viewBox="0 0 26 26" class="me-2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="13" cy="13" r="13" fill="#FF0000"/>
                        <path d="M13.0498 7V15M13.0996 19V19.1L13 19.1002V19H13.0996Z" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                                           
                }
               <span class="text-brand-purple fs-14"> {{ toast.text }} </span>
            </div>
                <svg (click)="toastService.dismiss(toast.id)" class="cross-icon" width="12" height="12" viewBox="0 0 10 10" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.99996 8.99996L5 5M5 5L1 1M5 5L9 1M5 5L1 9" stroke="#A0A0A0" stroke-width="1.4"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
        </div>
    </div>
</div>